<script setup lang="ts">
import { onMounted, onUnmounted, watch } from 'vue'
import { RouterView } from 'vue-router'
import ToastContainer from '@/components/common/ToastContainer.vue'
import { useAuthStore } from '@/stores/auth'
import { useChatStore } from '@/stores/chat'
import { usePresenceStore } from '@/stores/presence'

const authStore = useAuthStore()
const chatStore = useChatStore()
const presenceStore = usePresenceStore()

// Sekme gizlenince soket KAPATILMAZ — arka planda da bildirim + ses gelsin.
// Görünür olunca: soket düştüyse yeniden bağlan + görünen okunmamışları işaretle.
const syncSocketWithVisibility = () => {
  if (!authStore.isAuthenticated) {
    return
  }

  if (document.visibilityState === 'visible') {
    chatStore.initializeWebSocket()
    presenceStore.fetchInitialPresence()
    chatStore.onWindowFocused()
  }
}

// Pencere odağı dönünce aktif sohbetteki okunmamışlar MARK_READ ile işaretlenir
// (odaksızken gelen mesajlar bilerek işaretlenmemişti).
const handleWindowFocus = () => {
  if (!authStore.isAuthenticated) {
    return
  }
  chatStore.onWindowFocused()
}

watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated) {
      chatStore.initializeWebSocket()
      presenceStore.fetchInitialPresence()
      // Web Push: SW kaydı + (izin varsa) VAPID aboneliği — arka planda, boot'u bloklamaz.
      import('@/utils/webPush').then(({ initWebPush }) => initWebPush())
      return
    }

    chatStore.disconnect()
    presenceStore.reset()
  },
  { immediate: true }
)

onMounted(() => {
  document.addEventListener('visibilitychange', syncSocketWithVisibility)
  window.addEventListener('focus', handleWindowFocus)
})

onUnmounted(() => {
  document.removeEventListener('visibilitychange', syncSocketWithVisibility)
  window.removeEventListener('focus', handleWindowFocus)
})
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>

<style>
/* Global styles are already imported in main.ts via style.css or main.css */
</style>
